import React from "react";
import DOMPurify from "dompurify";
import { mediaUrl } from "../lib/format";

export default function Blocks({ blocks = [], className = "", testid = "blocks" }) {
  if (!blocks || blocks.length === 0) return null;
  return (
    <div className={className} data-testid={testid}>
      {blocks.map((b, i) => (
        <div key={i} className="mb-6" data-testid={`${testid}-${i}`}>
          {b.type === "heading" && <h2 className="font-heading font-bold text-2xl tracking-tighter mb-2">{b.text}</h2>}
          {b.type === "text" && <p className="text-muted-foreground leading-relaxed whitespace-pre-line">{b.text}</p>}
          {b.type === "image" && b.url && <img src={mediaUrl(b.url)} alt={b.text || ""} className="w-full rounded-2xl border border-border" />}
          {b.type === "html" && b.text && <div className="prose prose-neutral max-w-none prose-headings:font-heading text-muted-foreground" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(b.text) }} />}
        </div>
      ))}
    </div>
  );
}
